"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InTheThickOfIt() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const photos = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_drum_kit_tracking.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_drum_kit_tracking.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_drum_kit_tracking.png-wvc-sizes",
    alt: "Close up of premium drum kit in the tracking room",
    stamp: "ROOM A · DRUMS",
    coords: "REC 11.02.2024",
    rotate: "-6deg",
    span: "col-span-1 md:col-span-6 md:row-span-2 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_exterior_industrial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_exterior_industrial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_exterior_industrial.png-wvc-sizes",
    alt: "Industrial exterior of The Garage Room",
    stamp: "GRG · EXTERIOR",
    coords: "REC 06.27.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_late_night_session.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_late_night_session.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_late_night_session.png-wvc-sizes",
    alt: "Late night recording session with low lighting",
    stamp: "NIGHT · 02:45",
    coords: "REC 06.19.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cassette_archive.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cassette_archive.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cassette_archive.png-wvc-sizes",
    alt: "Archive of cassette tapes on a shelf",
    stamp: "TAPE · SAT",
    coords: "REC 06.02.2024",
    rotate: "2deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_pedalboard_closeup.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_pedalboard_closeup.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_pedalboard_closeup.png-wvc-sizes",
    alt: "Close-up of a boutique pedalboard setup",
    stamp: "FX · CHAIN",
    coords: "REC 05.14.2024",
    rotate: "-7deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_vocalist_tracking_live.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_vocalist_tracking_live.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_vocalist_tracking_live.png-wvc-sizes",
    alt: "Vocalist tracking live in the booth",
    stamp: "VOCAL · BOOTH",
    coords: "REC 05.01.2024",
    rotate: "-4deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_guitar_rack_lineup.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_guitar_rack_lineup.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_guitar_rack_lineup.png-wvc-sizes",
    alt: "Lineup of electric guitars in the studio rack",
    stamp: "AXES · RACK",
    coords: "REC 04.22.2024",
    rotate: "6deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_neon_sign_garage.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_neon_sign_garage.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_neon_sign_garage.png-wvc-sizes",
    alt: "The Garage Room neon sign glowing in the dark",
    stamp: "EST. 2024",
    coords: "REC 04.09.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cable_nest_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cable_nest_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_cable_nest_detail.png-wvc-sizes",
    alt: "A nest of XLR cables on the studio floor",
    stamp: "SIGNAL · PATH",
    coords: "REC 03.18.2024",
    rotate: "3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_band_rehearsal_grit.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_band_rehearsal_grit.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_band_rehearsal_grit.png-wvc-sizes",
    alt: "Local band practicing in the main garage space",
    stamp: "LIVE · SESSION",
    coords: "REC 03.04.2024",
    rotate: "-3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_mixing_console_hands.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_mixing_console_hands.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_mixing_console_hands.png-wvc-sizes",
    alt: "Engineer adjusting levels on a vintage console",
    stamp: "MIX · DESK 02",
    coords: "REC 02.28.2024",
    rotate: "5deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_tube_amp_glow.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_tube_amp_glow.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/studio_tube_amp_glow.png-wvc-sizes",
    alt: "Glowing vacuum tubes in a vintage guitar amp",
    stamp: "GEAR · TUBE 01",
    coords: "REC 01.22.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }];
  return <section data-section-id="1411" id="in-the-thick-of-it" className="bg-background text-foreground py-28 md:py-40 relative overflow-hidden">
      <style>{`
        @keyframes stamp-breathe {
          0%, 100% { transform: rotate(var(--stamp-rotate)) scale(1); }
          50% { transform: rotate(calc(var(--stamp-rotate) + 1.5deg)) scale(1); }
        }
        .stamp-idle { animation: stamp-breathe 6s ease-in-out infinite; }
        .photo-card:hover .stamp-idle {
          animation: none;
          transform: rotate(calc(var(--stamp-rotate) + 4deg));
          transition: transform 0s;
        }
        .photo-img {
          transition: transform 600ms cubic-bezier(0.16, 1, 0.3, 1);
        }
        .photo-card:hover .photo-img {
          transform: scale(1.04);
        }
        .reveal {
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 600ms cubic-bezier(0.16, 1, 0.3, 1), transform 600ms cubic-bezier(0.16, 1, 0.3, 1);
        }
        .reveal.is-visible {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--primary) 0, var(--primary) 1px, transparent 1px, transparent 40px)"
    }} />

      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
        <div ref={header.ref} className={`reveal ${header.isVisible ? "is-visible" : ""} grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24`}>
          <div className="md:col-span-5">
            <div className="font-mono uppercase text-xs md:text-sm mb-8 text-primary font-medium" style={{
            letterSpacing: "0.2em"
          }}>
              SECTION_02 // THE_SCENE_GALLERY
            </div>
            <h2 className="font-default text-foreground uppercase" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.0
          }}>
              In the{" "}
              <span className="text-primary">
                Thick
              </span>{" "}
              of it.
            </h2>

            <div className="mt-10 flex items-center gap-3">
              <div className="h-px flex-1 bg-border" />
              <div className="w-1.5 h-1.5" style={{
              background: "var(--primary)"
            }} />
            </div>
          </div>

          <div className="md:col-span-7 flex flex-col md:items-end md:text-right justify-between gap-6">
            <div className="font-mono uppercase text-xs text-muted-foreground" style={{
            letterSpacing: "0.12em"
          }}>
              LIVE_TRACKING_ARCHIVE · 2024.10
            </div>
            <p className="font-mono text-xs md:text-sm max-w-sm text-muted-foreground leading-relaxed" style={{
            letterSpacing: "0.04em"
          }}>
              Raw moments captured during tracking sessions and rehearsals.
              <br />
              No filters, just sweat and signal · The Garage Room.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-12 gap-4 md:gap-6 auto-rows-auto">
          {photos.map((photo, i) => {
          const reveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div key={i} data-index={i} ref={reveal.ref} className={`reveal ${reveal.isVisible ? "is-visible" : ""} ${photo.span} photo-card group relative overflow-hidden`} style={{
            transitionDelay: `${i % 4 * 100}ms`,
            background: "var(--card)",
            border: "1px solid var(--border)"
          }}>
                <div className="absolute inset-0 overflow-hidden">
                  <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="photo-img w-full h-full object-cover" style={{
                filter: "grayscale(0.2) contrast(1.2) saturate(0.9)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 mix-blend-multiply" style={{
                background: "linear-gradient(180deg, transparent 0%, hsla(220, 15%, 5%, 0.6) 100%)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 opacity-[0.1] pointer-events-none mix-blend-overlay" style={{
                backgroundImage: "repeating-conic-gradient(var(--primary) 0% 0.0001%, transparent 0.0001% 0.0002%)",
                backgroundSize: "4px 4px"
              }} />
                </div>

                <div className={`absolute ${photo.corner} z-10 stamp-idle`} style={{
              ["--stamp-rotate" as string]: photo.rotate,
              transform: `rotate(${photo.rotate})`
            } as React.CSSProperties}>
                  <div className="relative flex items-center justify-center" style={{
                width: "84px",
                height: "84px"
              }}>
                    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" aria-hidden="true">
                      <defs>
                        <filter id={`rough-${i}`}>
                          <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" />
                          <feDisplacementMap in="SourceGraphic" scale="2" />
                        </filter>
                      </defs>
                      <rect x="10" y="10" width="80" height="80" fill="none" stroke="var(--primary)" strokeWidth="2" filter={`url(#rough-${i})`} />
                      <rect x="18" y="18" width="64" height="64" fill="none" stroke="var(--primary)" strokeWidth="1" filter={`url(#rough-${i})`} />
                    </svg>
                    <div className="relative text-center px-2">
                      <div className="font-mono uppercase font-bold leading-tight" style={{
                    color: "var(--primary)",
                    fontSize: "0.55rem",
                    letterSpacing: "0.05em"
                  }}>
                        {photo.stamp}
                      </div>
                      <div className="mt-1 w-4 h-px mx-auto" style={{
                    background: "var(--primary)"
                  }} />
                      <div className="font-mono uppercase mt-1" style={{
                    color: "var(--primary)",
                    fontSize: "0.45rem",
                    letterSpacing: "0.15em"
                  }}>
                        GRG
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 z-10 flex items-end justify-between gap-2">
                  <div className="font-mono uppercase text-[0.6rem] md:text-[0.65rem] text-white-raw/90" style={{
                letterSpacing: "0.12em"
              }}>
                    {photo.coords}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="h-px w-6 bg-primary" />
                    <div className="w-1 h-1" style={{
                  background: "var(--primary)"
                }} />
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-16 md:mt-24 flex items-center gap-3">
          <div className="font-mono uppercase text-xs text-primary font-semibold" style={{
          letterSpacing: "0.16em"
        }}>
            END_OF_REEL // 12_OF_12
          </div>
          <div className="h-px flex-1 bg-border" />
          <div className="w-1.5 h-1.5" style={{
          background: "var(--primary)"
        }} />
        </div>
      </div>
    </section>;
}